















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import { getDefaultAloFlux, AloFlux } from '@/models/alo/AloFlux'
import {FluxRestrictFlag} from '@/enum/FluxRestrictFlag'
import { toSubArray } from '@/utils/groupBy'

@Component({
  name: 'EditParamCw',
  components:{EditBaseFlux}
})
export default class EditParamCw extends Vue {
    
  private flux:AloFlux = getDefaultAloFlux()
  private showDrawer = false
  private saving = false  

  edit(item:AloFlux) {    
    this.flux = (this.$refs.baseEdit as EditBaseFlux).edit(item)
  }  
 
  get builders() {
    return this.$store.myGetters.fluxBuildersList
  }

  get restrictionsAccesGroup() {    
    return toSubArray(Object.keys(FluxRestrictFlag),2)
  }

  get restricted(){
    return this.flux.flxRestrictedFlag && this.flux.flxRestrictedFlag.length >0 &&  this.flux.flxRestrictedFlag != 'none'?this.flux.flxRestrictedFlag.split(', '):[]
  }

  set restricted(value:Array<string>)
  {
    this.flux.flxRestrictedFlag = value.length>0?value.join(', '):'none'
  }

}
